export const PremiumTab = {
  namespaced: true,
  state: {
    selectedPremiumTab: ''
  },
  getters: {
    selectedPremiumTab: (state) => state.selectedPremiumTab
  },
  mutations: {
    UPDATE_SELECTED (state, payload) {
      state.selectedPremiumTab = payload
    }
  },
  actions: {
    action_SetSelected ({ commit }, selectedPremiumTab) {
      commit('UPDATE_SELECTED', selectedPremiumTab)
    }
  }
}
